import { CommandAlreadyExistsError } from './CommandAlreadyExistsError';
import { MustContainFunctionError } from './MustContainFunctionError';
import { MustExtendRocketletError } from './MustExtendRocketletError';
import { NotEnoughMethodArgumentsError } from './NotEnoughMethodArgumentsError';
import { RequiredApiVersionError } from './RequiredApiVersionError';

export {
    CommandAlreadyExistsError,
    MustContainFunctionError,
    MustExtendRocketletError,
    NotEnoughMethodArgumentsError,
    RequiredApiVersionError,
};
